module.exports = __webpack_public_path__ + "static/img/gaozhongshuxue7.63b70e66.jpg";